import { render } from "./PurchaseList.vue?vue&type=template&id=de9a6d76&scoped=true"
import script from "./PurchaseList.vue?vue&type=script&lang=js"
export * from "./PurchaseList.vue?vue&type=script&lang=js"

import "./PurchaseList.vue?vue&type=style&index=0&id=de9a6d76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de9a6d76"]])

export default __exports__